import React, {
  useState,
  useMemo,
  Fragment,
  memo,
  useEffect,
  useCallback,
  useContext,
} from "react";
import Countdown from "react-countdown";
import _ from "lodash";
import {
  useTable,
  usePagination,
  useFilters,
  useGlobalFilter,
  useSortBy,
  useRowSelect,
} from "react-table";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoadingMutation from "../Loading/LoadingMutation";
import { checkRole } from "../../utils/role";
import PDFMerger from "pdf-merger-js/browser";
import Minizip from "minizip-asm.js";

// CONTEXT
import { SearchBarContext } from "../../context/SearchBarContext";

// COMPONENTS
import MoneyDatePicker from "../MoneyDatePicker";
import PrevPage from "../Pagination/PrevPage";
import NumberPage from "../Pagination/NumberPage";
import NextPage from "../Pagination/NextPage";
import SelectRows from "../Pagination/SelectRows";
// import SearchTable from "../Search/SearchTable";

// UTILS
import { pad, getCurrentLocalDateTime } from "../../utils/getLocalDateTime";

// OTHER
import numeral from "numeral";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";
import AWS from "aws-sdk";
import GenFinalPdf from "../Loan/GenFinalPdf";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";

const getDefaultPayDate = (days = 3) => {
  let result = new Date();
  result.setDate(result.getDate() + days);
  return result;
};

const IndeterminateCheckbox = React.forwardRef(
  ({ onChange, id, selectedFlatRows, flatRows, ...rest }, ref) => {
    useEffect(() => {
      const getIdAll = document.getElementById("ALL");
      if (selectedFlatRows?.length > 0) {
        const newRows = flatRows
          .map((row) => {
            // if (row.original.loan_status !== "สมบูรณ์") {
            return row;
            // }
          })
          .filter((row) => row);
        getIdAll.checked = newRows.length === selectedFlatRows.length;
        getIdAll.indeterminate = newRows.length !== selectedFlatRows.length;
        return;
      }
      getIdAll.indeterminate = false;
      getIdAll.checked = false;
    }, [selectedFlatRows]);

    return (
      <>
        <input
          type="checkbox"
          id={id}
          onChange={onChange}
          {...rest}
          style={{ width: "20px", height: "20px" }}
        />
      </>
    );
  }
);

const Row = ({ row, i, value, getData, query, setSelectedRows }) => {
  const { user } = useSelector((state) => state.initializeApp);

  const [form, setForm] = useState({
    tx: "",
    transferDate: new Date(),
  });
  const [error, setError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [contractFinal, setContractFinal] = useState(null);

  // console.log("original", row.original);

  useEffect(() => {
    const fetchFinal = async () => {
      const final = await Storage.get(
        `${row.original.request_id}_contract_final.pdf`
      );
      setContractFinal(final);
    };
    fetchFinal();
  }, []);

  const onChangeForm = (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const onContract = async () => {
    try {
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          try {
            await API.put(
              "MoneyHubAdmin",
              `/transferLoan/${row.original.request_id}`,
              {},
              {
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              }
            );
          } catch (error) {
            console.log("update status loan request contract", error);
            await Swal.fire({
              title: "ERROR",
              text: error?.response?.data?.message
                ? error.response.data.message
                : "อัพเดตข้อมูลไม่สำเร็จ",
              icon: "error",
              confirmButtonText: "ยืนยัน",
            });
          }
        },
      });
    } catch (error) {
      console.log("error on contract", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const onComplete = async (e) => {
    e.stopPropagation();

    const { phone_number, requestamount, loan_id } = row.original;

    // console.log("row", row.original);

    try {
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          if (!form.tx) {
            setError(true);
            return {
              error: true,
              errorMessage: "โปรดกรอกเลขอ้างอิงการโอนงิน",
            };
          }
          let executeTime = getCurrentLocalDateTime(new Date());

          try {
            const checkLoan = await API.get(
              "MoneyHubAdmin",
              `/loan/checkLoanExists/${row.original.loan_kbank_id}`,
              {
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              }
            );

            if (checkLoan?.type === "WARNING") {
              return await Swal.fire({
                title: "WARNING",
                text: checkLoan?.message,
                icon: "error",
                confirmButtonText: "ยืนยัน",
              });
            }

            await API.put("MoneyHubAdmin", "/loanRequest", {
              body: {
                requestamount: row.original.requestamount,
                request_id: row.original.request_id,
                phone_number: row.original.phone_number, //WHERE KEY 1
                timestamp: row.original.timestamp, //WHERE KEY 2
                fileBuro: row.original?.originalFileBuro,
                deviceToken: row.original?.deviceToken,
                reason: row.original?.reason,
                status:
                  _.upperCase(form.tx) !== "F"
                    ? "สมบูรณ์"
                    : "รอผู้ยื่นคำร้องแก้ไข",
                reason:
                  _.upperCase(form.tx) !== "F"
                    ? ""
                    : "ธนาคารหรือเลขบัญชีของท่านผิดกรุณากรอกใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่",
                referal_one: row.original?.referal_one,
                referal_two: row.original?.referal_two,
                paydate: row.original?.paydate,
                adminName: user.username,
                executeTime: executeTime?.timestamp,
                name: row.original.name,
                lastname: row.original.lastname,
                refinance_id: row.original.refinance_id,
                loan_kbank_id: row.original.loan_kbank_id,
                tx: form.tx,
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            });

            if (_.upperCase(form.tx) !== "F") {
              await API.post("MoneyHubAdmin", "/loan", {
                body: {
                  transferDate: form.transferDate,
                  phone_number: row.original.phone_number,
                  request_id: row.original.request_id,
                  purpose: row.original.purpose,
                  period: row.original.period,
                  requestamount: row.original.requestamount,
                  payPerMonth: row.original.payPerMonth,
                  completedAt: executeTime.date, //MARK
                  dueTime: row.original.paydate,
                  fullname: `${row.original.name} ${row.original.lastname}`,
                  name: row.original.name,
                  lastname: row.original.lastname,
                  adminName: user.username,
                  deviceToken: row.original.deviceToken,
                  promo: row.original.promo,
                  citizenid: row.original.citizenid,
                  birthdateTh: row.original.birthdateTh,
                  currentAddress: row.original.currentAddress,
                  bankNo: row.original.bankNo,
                  addressDesc: row.original.addressDesc,
                  loan_kbank_id: row.original.loan_kbank_id,
                  refinance_id: row.original.refinance_id,
                  refinance_date: row.original.refinance_date,
                  loanRequest: row.original,
                },
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              });

              if (row.original.refinance_id) {
                await API.put("MoneyHubAdmin", "/loan/refinanceLoan", {
                  body: {
                    refinance_id: row.original.refinance_id,
                  },
                });
              }
            }
          } catch (error) {
            await Swal.fire({
              title: "ERROR",
              text: error?.response?.data?.message
                ? error.response.data.message
                : "อัพเดตข้อมูลไม่สำเร็จ",
              icon: "error",
              confirmButtonText: "ยืนยัน",
            });
          }
        },
      });
      if (!result.isConfirmed) return;
      if (result.value.error) {
        return await Swal.fire({
          title: "WARNING",
          text: result.value.errorMessage,
          icon: "error",
          confirmButtonText: "ยืนยัน",
        });
      }
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      // const sns = new AWS.SNS({
      //   region: "ap-southeast-1",
      //   accessKeyId: "AKIA25CST76C5WILBFNI",
      //   secretAccessKey: "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",
      // });
      // const format_phone_number =
      //   "+66" + phone_number.slice(1, phone_number.length);
      // await sns
      //   .publish({
      //     Message: `บริษัท มันนี่ฮับ เซอร์วิส โอนเงินสินเชื่อเลขที่ ${row.original.request_id.slice(
      //       -6
      //     )} จำนวน ${numeral(requestamount).format(
      //       "0,0"
      //     )} บาท เข้าบัญชีท่านเรียบร้อยแล้ว`,
      //     PhoneNumber: format_phone_number,
      //     MessageAttributes: {
      //       "AWS.SNS.SMS.SMSType": {
      //         DataType: "String",
      //         StringValue: "Transactional",
      //       },
      //     },
      //   })
      //   .promise();
      await getData(query);
      setSelectedRows([]);
    } catch (error) {
      console.log("Error", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const onTx = (e) => {
    setForm((prev) => {
      return {
        ...prev,
        tx: e.target.value,
      };
    });
  };

  function tryParseJSON(jsonString) {
    try {
      var o = JSON.parse(jsonString);
      if (o && typeof o === "object") {
        return o;
      }
    } catch (e) {}

    return false;
  }
  const Asset = useCallback(({ asset }) => {
    if (asset == undefined || asset.length < 1)
      return <div className="h-4"></div>;
    return (
      <div>
        {asset?.length &&
          asset.map((data, index) => {
            return (
              <div
                key={index}
                className="border border-gray-200 bg-white p-4 flex flex-row"
              >
                <div className="w-1/2">
                  <S3Image imgKey={data.img} className="w-full h-auto" />
                </div>
                <div className="w-1/2 text-right">
                  <div>
                    ประเภท{" "}
                    <span className="text-gray-700 font-bold">{data.type}</span>
                  </div>
                  <div>
                    จำนวน{" "}
                    <span className="text-gray-700 font-bold">
                      {Number(data.value).toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    );
  }, []);

  const Debt = useCallback(({ debt }) => {
    // console.log("debt", debt);
    return (
      <div>
        {debt?.length &&
          debt.map((data, index) => {
            return (
              <div key={index} className="border border-gray-200 bg-white p-4">
                <div>
                  ประเภท{" "}
                  <span className="text-gray-700 font-bold">{data.type}</span>
                </div>
                <div>
                  จำนวน{" "}
                  <span className="text-gray-700 font-bold">
                    {Number(data.amount).toLocaleString()}
                  </span>
                </div>
                <div>
                  ผ่อนต่อเดือน{" "}
                  <span className="text-gray-700 font-bold">
                    {Number(data.payperinsallment).toLocaleString()}
                  </span>
                </div>
              </div>
            );
          })}
      </div>
    );
  }, []);

  const Gallery = useCallback(({ paths, max = "grid-cols-4 " }) => {
    if (paths.length == undefined || paths.length < 1) return <div></div>;

    return (
      <div className={"grid grid-cols-1 md:grid-cols-2  gap-1 lg:" + max}>
        {paths?.length &&
          paths.map((item) => {
            return (
              <S3Image preview="true" imgKey={item} className="w-full h-auto" />
            );
          })}
      </div>
    );
  }, []);

  const Title = useCallback(({ title }) => {
    return <h3 className="mb-4 text-blueGray-800 font-black">{title}</h3>;
  }, []);

  const Content = useCallback(
    ({ title, value, textColor = "text-gray-700" }) => {
      return (
        <div className={"text-gray-700"}>
          {title}
          <span className={textColor + " font-bold break-all	"}>
            &nbsp;{value}
          </span>
        </div>
      );
    },
    []
  );

  const ContentImage = useCallback(({ value }) => {
    return <S3Image imgKey={value} className="w-full h-auto" />;
  }, []);

  const GenFinal = async () => {
    try {
      const filename = `${row?.original?.request_id}_contract_final.pdf`;
      const blob = await pdf(<GenFinalPdf data={row?.original} />).toBlob();
      saveAs(blob, filename);
    } catch (error) {
      alert("error", error);
      console.log("error", error);
    }
    // const merger = new PDFMerger();
    // let blobFinalPDF = await pdf(<GenFinalPdf data={row?.original} />).toBlob();
    // await merger.add(blobFinalPDF);
    // const blobMerger = await merger.saveAsBuffer();
    // const mz = new Minizip();
    // const filename = `${row?.original?.request_id}_contract_final.pdf`;
    // mz.append(filename, blobMerger);
    // const fileMerger = new File([mz.zip()], filename);
    // await Storage.put(filename, fileMerger);
  };

  // const checkRole = () => {
  //   const roles = user.groups || [];
  //   if (!roles?.length) return false;
  //   return roles.some((role) => role === "SuperAdmin");
  // };

  const btnCompleteJob = () => {
    if (
      checkRole(user.groups, [
        "SuperAdmin",
        "Analyze",
        "AnalyzeApprove",
        "CustomerService",
        "Admin",
      ])
    ) {
      return (
        <button
          onClick={onComplete}
          type="button"
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-500 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
        >
          Complete
        </button>
      );
    }

    return null;
  };

  const btnContract = () => {
    if (
      checkRole(user.groups, [
        "SuperAdmin",
        "Analyze",
        "AnalyzeApprove",
        "CustomerService",
      ])
    ) {
      return (
        <button
          onClick={onContract}
          type="button"
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-yellow-500 text-base font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm"
        >
          Contract
        </button>
      );
    }

    return null;
  };

  const ContentFilePdf = useCallback(({ title, value }) => {
    if (value) {
      return (
        <div className="text-blue-700">
          <a target="_blank" href={`${value}`} className="w-full h-auto">
            {title}
          </a>
        </div>
      );
    }

    return <div className="text-gray-700">ไม่มีไฟล์{title}</div>;
  }, []);

  const getButtonStatus = () => {
    const loan_status = value.loan_status;
    switch (loan_status) {
      case "ยืนยัน":
        return [btnCompleteJob()];
      // case "สัญญาสมบูรณ์":
      //   return [btnCompleteJob()];
      default:
        return [];
    }
  };

  // if (showModal) {
  //   return <GenFinalPdf data={row.original} />;
  // }

  return (
    <Fragment>
      <tr
        {...row.getRowProps()}
        onClick={() => setShowModal(true)}
        className={classNames(
          "cursor-pointer hover:bg-blueGray-200 transition-all duration-300",
          {
            "bg-white": i % 2 === 0,
            "bg-gray-100": i % 2 !== 0,
            "bg-blue-50": value.newUpdate <= 30,
          }
        )}
      >
        {row.cells.map((cell, index) => {
          return (
            <td
              className={"p-4 text-gray-700 text-sm text-center"}
              {...cell.getCellProps()}
            >
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
      {showModal && (
        <div
          className="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className=" h-screen  pb-20 text-center sm:p-0">
            <div className="flex-1 bg-green-500"></div>
            <div className="flex-1 bg-gray-100 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-0  h-screen  w-full ">
              <div className="mx-4 pt-5 pb-4 sm:p-6 sm:pb-4 flex-1">
                <div className="sm:flex sm:items-start ">
                  {/* <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-blue-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div> */}
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                    <h3
                      className="text-lg leading-6 font-medium text-gray-900"
                      id="modal-title"
                    >
                      {value.request_id} {"  / "} {value.loan_kbank_id}
                      {" / "}
                      <span className="text-blue-500">{value.loan_status}</span>
                    </h3>
                    <div
                      className={
                        "mt-2  overflow-auto md:min-h-screen-80   h-450-px  grid grid-cols-1 lg:grid-cols-3 gap-1"
                      }
                    >
                      <div className="p-4 bg-gray-50">
                        {Title({ title: "ข้อมูลสินเชื่อ" })}
                        {Content({
                          title: "การประเมินขั้นต้น",
                          value: Boolean(value.pass) ? "ผ่าน" : "ไม่ผ่าน",
                          textColor: "text-green-500",
                        })}
                        {Content({
                          title: "คะแนน",
                          value: Math.round(value.totalScore),
                        })}
                        {Content({
                          title: "ประเภท",
                          value: value.purpose,
                        })}
                        {Content({
                          title: "วงเงินที่ได้รับ",
                          value: `${Number(
                            value.requestamount
                          ).toLocaleString()} บาท`,
                          textColor: "text-black",
                        })}
                        {Content({
                          title: "วงเงินที่ขอ",
                          value: `${Number(value.amount).toLocaleString()} บาท`,
                        })}
                        {Content({
                          title: "ระยะเวลา",
                          value: `${value.period} งวด`,
                        })}
                        {Content({
                          title: "ผ่อนต่อเดือน",
                          value: `${Number(
                            value.payPerMonth
                          ).toLocaleString()} บาท`,
                          textColor: "text-black",
                        })}
                        {/* {Content({
                          title: "บุคคลค้ำประกัน",
                          value:
                            value.garuntor == "{}" ? "ไม่มี" : value.garuntor,
                        })} */}
                        <div className="w-full p-3 my-2 text-gray-500 rounded-sm border border-gray-200 bg-gray-50">
                          <div>
                            ธนาคาร:{" "}
                            <span className="font-bold text-gray-700">
                              {value.bank}
                            </span>
                          </div>
                          <div>
                            เลขที่บัญชี:{" "}
                            <span className="font-bold text-gray-700">
                              {value.bankNo}
                            </span>
                          </div>
                          <div>
                            ชื่อบัญชี:{" "}
                            <span className="font-bold text-gray-700">
                              {value.bankAccName}
                            </span>
                          </div>
                          <div>
                            รหัสสาขา:{" "}
                            <span className="font-bold text-gray-700">
                              {value.bankBrachCode || " "}
                            </span>
                          </div>
                        </div>

                        {Content({
                          title: "สิทธ์พิเศษ",
                          value: value.privillege,
                        })}
                        {value.promo != 0 && (
                          <div className="w-full p-3 mt-2 text-green-500 rounded-sm border border-green-200 bg-green-50">
                            ได้รับส่วนลดดอกเบี้ย: {value.promo} %
                          </div>
                        )}

                        {value.refinance_id != undefined &&
                          value.refinance_id != "" && (
                            <div className="w-full p-3 mt-2 text-blue-500 rounded-sm border border-blue-200 bg-blue-50">
                              รีไฟแนนซ์มาจาก: {value.refinance_id}
                            </div>
                          )}

                        {/* {Content({
                          title: "วันที่โอนเงิน",
                          value: new Intl.DateTimeFormat("th-TH").format(
                            value.payDate ? new Date(value.paydate) : new Date()
                          ),
                          textColor: "text-green-600",
                        })} */}
                        <div className="my-3 w-full">
                          วันที่โอนเงิน
                          <input
                            max={getCurrentLocalDateTime(new Date()).fullDate}
                            defaultValue={format(
                              new Date(form.transferDate),
                              "yyyy-MM-dd"
                            )}
                            name="transferDate"
                            className="border boder-gray-300 p-2 ml-4"
                            type="date"
                            onChange={onChangeForm}
                          />
                        </div>
                        {row.original.tx ? (
                          Content({
                            title: "Tx (เลขอ้างอิงการโอนงิน)",
                            value: value.tx,
                            textColor: "text-green-600",
                          })
                        ) : (
                          <div className="flex flex-col text-gray-700">
                            Tx (เลขอ้างอิงการโอนงิน)
                            <input
                              onChange={onTx}
                              className="border-2 border-blue-400"
                              type="text"
                              name="tx"
                            />
                            {error && !form.tx && (
                              <span className="text-red-400 text-sm">
                                โปรดกรอกเลขอ้างอิงการโอนงิน
                              </span>
                            )}
                          </div>
                        )}
                        <div className="my-3 w-full">
                          {Content({
                            title: "เหตุผลในการปฏิเสธ",
                            value: value.reason || " - ",
                          })}
                        </div>
                      </div>

                      <div className="p-4 bg-gray-50">
                        {Title({ title: "ข้อมูลส่วนบุคคล" })}
                        {Content({
                          title: "ชื่อ",
                          value: `${value.article} ${value.name} ${value.lastname} (${value.nickname})`,
                        })}

                        {Content({
                          title: "หมายเลขบัตรประจำตัวประชาชน",
                          value: value.citizenid,
                        })}
                        {Content({
                          title: "วันหมดอายุบัตร",
                          value: value.citizenexpiredate,
                        })}
                        {Content({
                          title: "เพศ",
                          value: value.gender,
                        })}
                        {Content({
                          title: "วัน/เดือน/ปี เกิด",
                          value: value.birthdateTh,
                        })}
                        {Content({
                          title: "อายุ",
                          value: value.age,
                        })}
                        {Content({
                          title: "สถานภาพ",
                          value: value.marritalStatus,
                        })}
                        {value.marritalStatus == "สมรส" &&
                          Content({
                            title: "คู่สมรส",
                            value: `${value.articlePartner} ${value.namePartner} ${value.lastnamePartner}`,
                          })}
                        {Content({
                          title: "จำนวนบุตร",
                          value: value.childern,
                        })}
                        {Content({
                          title: "การศึกษา",
                          value: value.education,
                        })}
                        {/* {Content({
                          title: "ศาสนา",
                          value: value.religion,
                        })} */}
                        {Content({
                          title: "เบอร์โทรศัพท์",
                          value: value.phone_number,
                        })}
                        {Content({
                          title: "อีเมล",
                          value: value.email,
                        })}
                        {Content({
                          title: "ไลน์ไอดี",
                          value: value.lineid,
                        })}
                        {Content({
                          title: "ที่อยู่ตามทะเบียนบ้าน",
                          value:
                            value.addressCode +
                            " " +
                            value.addressDesc +
                            " " +
                            value.address,
                        })}
                        {Content({
                          title: "ที่อยู่ปัจจุบัน ",
                          value:
                            value.officialAddressCode +
                            " " +
                            value.officialAddressDesc +
                            " " +
                            value.currentAddress,
                        })}
                        <div className="p-4 bg-gray-50">
                          {Content({
                            title: "พิกัด ณ ตอนยื่นกู้",
                            value: value.latitude + " , " + value.longitude,
                          })}
                        </div>
                      </div>
                      <div className="p-4 bg-gray-50">
                        {Title({ title: " ข้อมูลการเงิน" })}
                        {Content({
                          title: "คงเหลือ",
                          value: `${Number(
                            value.income - value.burden - value.burdenSum
                          ).toLocaleString()} บาท`,
                          textColor: "text-black",
                        })}
                        {Content({
                          title: "รายได้",
                          value: `${Number(value.income).toLocaleString()} บาท`,
                          textColor: "text-green-600",
                        })}
                        {Content({
                          title: "รายจ่าย",
                          value: `${Number(value.burden).toLocaleString()} บาท`,
                          textColor: "text-red-600",
                        })}
                        {Content({
                          title: "ภาระหนี้สิน",
                          value: `${Number(
                            value.burdenSum
                          ).toLocaleString()} บาท`,
                          textColor: "text-orange-600",
                        })}
                        <div className="text-gray-700"> ภาระหนี้สิน</div>
                        <Debt debt={tryParseJSON(value?.dataDebt)} />
                        {/* <div className="text-gray-700"> ทรัพย์สิน </div>
                        <Asset asset={tryParseJSON(value?.dataAsset)} /> */}

                        <div className="border-b border-gray-300 mb-4"></div>
                        {Title({ title: " ข้อมูลการงาน" })}

                        {Content({
                          title: "อาชีพ",
                          value: value.careertype,
                        })}
                        {Content({
                          title: "สถานประกอบการ",
                          value: value.company,
                        })}
                        {Content({
                          title: "เบอร์โทรสถานประกอบการ",
                          value:
                            value.job_phone + "(" + value?.job_phone_ext + ")",
                        })}
                        {Content({
                          title: "ที่อยู่สถานประกอบการ",
                          value: value.job_address,
                        })}
                        {Content({
                          title: "ตำแหน่งล่าสุด",
                          value: value.jobposition,
                        })}
                        {Content({
                          title: "อายุงาน",
                          value: value.jobAge + " เดือน",
                        })}
                      </div>

                      <div className="bg-gray-50 p-4">
                        {Title({ title: "ไฟล์สัญญา" })}

                        {ContentFilePdf({
                          title: "สัญญาPDPA",
                          value: value.pdpaUri,
                        })}
                        {ContentFilePdf({
                          title: "สัญญาเงินกู้",
                          value: value.contractUri,
                        })}
                        {ContentFilePdf({
                          title: "สัญญาเงินกู้ Final",
                          value: `${contractFinal}`,
                        })}

                        {/* {row?.original?.contractGenFinalUri === "" ? (
                          <div>1</div>
                        ) : ( */}
                        {/* <div>
                            <button
                              onClick={GenFinal}
                              className="cursor-pointer text-sm mt-1 mb-1 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-2 py-1 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                              สัญญาเงินกู้ Gen Final
                            </button>
                          </div> */}
                        {/* )} */}

                        <div>
                          <button
                            onClick={GenFinal}
                            className="cursor-pointer text-sm mt-1 mb-1 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-2 py-1 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            สัญญาเงินกู้ back end
                          </button>
                        </div>

                        {Content({
                          title: "รหัสเปิดไฟล์",
                          value: value?.passwordPdf,
                        })}

                        {value?.statementUris !== "" &&
                          value?.statementUris.map((document) => {
                            return (
                              <ContentFilePdf
                                title={document.title}
                                value={document.value}
                              />
                            );
                          })}

                        {ContentFilePdf({
                          title: "เอกสารเครดิตบูโร",
                          value: value.fileBuro,
                        })}
                      </div>

                      <div className="bg-gray-50 p-4">
                        {Title({ title: "บุคคลอ้างอิงลำดับที่ 1" })}
                        {Content({
                          title: "ชื่อ",
                          value: value.referalName,
                        })}
                        {Content({
                          title: "เบอร์โทรศัพท์",
                          value: value.referalPhone,
                        })}
                        {Content({
                          title: "ความสัมพันธ์",
                          value: value.relation,
                        })}

                        <label class="inline-flex items-center">
                          <input
                            disabled
                            checked
                            type="checkbox"
                            class="form-checkbox"
                          />
                          <span class="ml-2">ยืนยันบุคคลอ้างอิงลำดับที่ 1</span>
                        </label>
                      </div>

                      <div className="bg-gray-50 p-4">
                        {Title({ title: "บุคคลอ้างอิงลำดับที่ 2" })}
                        {Content({
                          title: "ชื่อ",
                          value: value.referalName2,
                        })}
                        {Content({
                          title: "เบอร์โทรศัพท์",
                          value: value.referalPhone2,
                        })}
                        {Content({
                          title: "ความสัมพันธ์",
                          value: value.relation2,
                        })}
                        <label class="inline-flex items-center">
                          <input
                            disabled
                            checked
                            type="checkbox"
                            class="form-checkbox"
                          />
                          <span class="ml-2">ยืนยันบุคคลอ้างอิงลำดับที่ 2</span>
                        </label>
                      </div>
                      <div className="col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-4 gap-1">
                        <div className="text-center col-span-2">
                          {Title({ title: "ภาพบัตรประจำตัวประชาชน" })}
                          <Gallery
                            max="grid-cols-2"
                            paths={tryParseJSON(value?.citizenUri)}
                          />
                        </div>
                        <div className="text-center">
                          {Title({ title: "ภาพถ่ายหน้าตรง" })}
                          {ContentImage({ value: value.selfieUri })}
                        </div>

                        {/* <div className="text-center">
                          {Title({ title: "ภาพทะเบียนบ้าน" })}
                          {ContentImage({ value: value.addressUri })}
                        </div> */}
                        <div className="text-center">
                          {Title({ title: "ภาพสมุดบัญชี" })}
                          {ContentImage({ value: value.bookbankUri })}
                        </div>
                      </div>

                      <div className="col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4">
                        <div className="text-center">
                          {Title({ title: "หนังสือรับรองเงินเดือน" })}
                          <Gallery paths={tryParseJSON(value?.slipUris)} />
                        </div>
                      </div>

                      <div className="col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4">
                        <div className="text-center">
                          {Title({ title: "แผนธุรกิจ" })}
                          <Gallery
                            paths={tryParseJSON(value?.businessContractUris)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 my-1 text-center border-t border-gray-300">
                <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                  <React.Fragment>
                    {getButtonStatus().map((element, index) => {
                      return element;
                    })}
                    <button
                      onClick={() => setShowModal(false)}
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    >
                      Back
                    </button>
                  </React.Fragment>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

function TransferLoanBackEnd({ data, getData, query, setSelectedRows }) {
  const { user } = useSelector((state) => state.initializeApp);

  const getStyleStatus = (status) => {
    switch (status) {
      case "ยืนยัน":
        return "text-purple-400";
      case "สมบูรณ์":
        return "text-green-600";
      case "สัญญาสมบูรณ์":
        return "text-yellow-600";
      default:
        console.log("UNKNOWN STATUS", status);
        break;
    }
  };

  const getDisabledCheckbox = (loan_status, disabled_import) => {
    switch (loan_status) {
      case "สมบูรณ์":
        return true;
      default:
        return false;
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Job. No.",
        accessor: "loan_kbank_id",
      },
      {
        Header: "Tx",
        accessor: "tx",
      },
      {
        Header: "ชื่อ",
        accessor: "name",
        Cell: ({ row }) => {
          const { name, lastname, nickname } = row.original;
          return <div>{`${name} ${lastname} (${nickname})`}</div>;
        },
      },
      {
        Header: "วงเงินที่ได้",
        accessor: "requestamount",
        Cell: ({ row }) => {
          return <div>{numeral(row.values.requestamount).format("0,0")}</div>;
        },
      },
      {
        Header: "วงเงินที่ขอ",
        accessor: "amount",
        Cell: ({ row }) => {
          return <div>{numeral(row.values.amount).format("0,0")}</div>;
        },
      },
      {
        Header: "ประเภทสินเชื่อ",
        accessor: "purpose",
      },
      {
        Header: "วันที่สร้าง",
        accessor: "timestamp",
        Cell: ({ row }) => {
          return (
            <div>{format(new Date(row.values.timestamp), "dd-MM-yyyy")}</div>
          );
        },
      },
      {
        Header: "วันที่แก้ไข",
        accessor: "executeTime",
        Cell: ({ row }) => {
          if (!row.values?.executeTime) return <div>-</div>;
          return (
            <div>
              {format(
                row.values.executeTime
                  ? new Date(row.values.executeTime)
                  : new Date(),
                "dd-MM-yyyy"
              )}
            </div>
          );
        },
      },
      {
        Header: "สถานะ",
        accessor: "loan_status",
        Cell: ({ row }) => {
          return (
            <div
              className={classNames(
                `${getStyleStatus(
                  row.values.loan_status
                )} py-1 px-0 rounded-md `
              )}
            >
              {row.values.loan_status}
            </div>
          );
        },
      },
      {
        Header: "Time Remain",
        accessor: "dueTime",
        Cell: ({ row }) => {
          if (row.original.loan_status === "สมบูรณ์") return <div>-</div>;

          return (
            <Countdown
              date={
                Date.now() +
                (new Date(row.values.dueTime).getTime() - Date.now())
              }
            />
          );
        },
      },
      {
        Header: "แก้ไขโดย",
        accessor: "adminName",
      },
    ],
    [data]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    toggleAllRowsSelected,
  } = useTable(
    {
      columns,
      data,
    },
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({
            flatRows,
            getToggleAllRowsSelectedProps,
            toggleRowSelected,
            rows,
            ...props
          }) => {
            const onChangeAll = (e) => {
              flatRows.forEach((row) => {
                const { loan_status, fileBuro } = row.original;
                // if (loan_status !== "สมบูรณ์") {
                toggleRowSelected(row.id, e.target.checked);
                // }
              });
            };

            return (
              <div>
                <IndeterminateCheckbox
                  onChange={onChangeAll}
                  flatRows={flatRows}
                  id="ALL"
                  // disabled={rows.every((row) =>
                  //   getDisabledCheckbox(
                  //     row.original.loan_status,
                  //     row.original.disabled_import
                  //   )
                  // )}
                  // {...getToggleAllRowsSelectedProps()}
                />
              </div>
            );
          },
          Cell: ({
            row,
            toggleRowSelected,
            selectedFlatRows,
            flatRows,
            ...props
          }) => {
            const loan_status = row.values.loan_status;

            return (
              <div className="pointer-events-auto cursor-pointer">
                <IndeterminateCheckbox
                  selectedFlatRows={selectedFlatRows}
                  flatRows={flatRows}
                  onClick={(e) => e.stopPropagation()}
                  {...row.getToggleRowSelectedProps()}
                  // disabled={getDisabledCheckbox(
                  //   loan_status,
                  //   row.original.disabled_import
                  // )}
                />
              </div>
            );
          },
        },
        ...columns,
      ]);
    }
  );
  useEffect(() => {
    setSelectedRows(selectedFlatRows);
  }, [selectedFlatRows]);

  return (
    <div className="mx-4 mb-2">
      <div className="bg-white rounded border border-gray-300 w-full overflow-x-auto ">
        <table {...getTableProps()} className="w-full whitespace-no-wrap">
          <thead className=" text-sm font-semibold tracking-wide text-gray-500  border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, i) => (
                  <th
                    {...column.getHeaderProps()}
                    className={classNames("px-4 py-3 text-center", {
                      "rounded-tl": i === 0,
                      "rounded-tr": i === headerGroup.headers.length - 1,
                    })}
                  >
                    {column.render("Header")}
                    <span>
                      {" "}
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <FontAwesomeIcon icon={faAngleDown} />
                        ) : (
                          <FontAwesomeIcon icon={faAngleUp} />
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800 text-gray-700 dark:text-gray-400"
            {...getTableBodyProps()}
          >
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <Row
                  setSelectedRows={setSelectedRows}
                  query={query}
                  key={row.getRowProps().key}
                  i={i}
                  row={row}
                  value={data[i]}
                  getData={getData}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TransferLoanBackEnd;
